import React, {useEffect, useState, useCallback, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {Button} from "react-bootstrap";
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";

const EmpToEmpListing = ({
                      getEmpMrfListing,
                      pendingListing,
                      match,
                      history
                    }) => {


  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const {baseUrl} = useContext(BaseUrl);

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      getEmpMrfListing(1)
      setIsLoading(false)
    })()
  }, []);
  const headers = [
    'MRF ID',
    'Material Type',
    'Scope',
    'Created By',
    'Created At',
    'Actions'
  ];

  useEffect(() => {
    if (pendingListing && pendingListing?.data && pendingListing?.data.length > 0) {
      const tableData = ['id','mrf_id','material_acquisition_type', 'scope', 'created_by', 'created_at'];
      const action = [{name: 'View Material', link: '/dashboard/view-mrf/2'},
        {name: 'Fulfill MRF', link: '/dashboard/fulfill-mrf/2'}
      ];
      const data = pendingListing?.data.map((element) =>
        Object.assign(
          ...tableData.map((key) => (
            key === 'created_by' ? {['created_by']: element?.created_by?.name} :
              key === 'material_acquisition_type' ? {['material_type']: element?.material_acquisition_type?.name !== undefined ? element?.material_acquisition_type?.name : 'Installation'} : {[key]: element[key]}
          )),
          {},
          {Action: action}
        )
      )
      if (data) {
        data && setListData(data);
      }
      setPageCount(Math.ceil(pendingListing.total / pendingListing.per_page));
    }
  }, [pendingListing])

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getEmpMrfListing(val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.empMrf}
      isLoading={isLoading}
      isGoback={true}
      // Buttons={headerBtns}
    >
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={pendingListing && pendingListing.data}
        srNo={pendingListing?.from}
      />
    </Layout>
  )
}

export default EmpToEmpListing